import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-boton-terciario-consulta',
  templateUrl: './boton-terciario-consulta.component.html',
  styleUrls: ['./boton-terciario-consulta.component.scss']
})
export class BotonTerciarioConsultaComponent {
  @Input() boton_texto: string;
  @Input() disabled: boolean = false;
  @Output("boton_funcion") boton_funcion: EventEmitter<any> = new EventEmitter<any>();

  ejecutarFuncion() {
    this.boton_funcion.emit();
  }
}
